/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", function () {
  const audio = document.getElementById("podcast-audio");
  const currentTimeElem = document.getElementById("current-time");
  const durationElem = document.getElementById("duration");
  const progress = document.querySelector(".audio-timeline .progress");
  const volumeBtn = document.getElementById("audio-volume-button");
  const volumeIcon = document.querySelector(".audio-volume-non-muted");
  const volumeMutedIcon = document.querySelector(".audio-volume-muted");
  const playIcon = document.querySelector(".play-pause__play");
  const pauseIcon = document.querySelector(".play-pause__pause");

  audio.addEventListener("loadedmetadata", () => {
    durationElem.textContent = formatTime(audio.duration);
  });

  audio.addEventListener("timeupdate", () => {
    currentTimeElem.textContent = formatTime(audio.currentTime);
    const percentage = (audio.currentTime / audio.duration) * 100;
    progress.style.width = percentage + "%";
  });

  volumeBtn.addEventListener("click", () => {
    if (audio.volume === 0) {
      setVolume(1);
      volumeIcon.style.display = "block";
      volumeMutedIcon.style.display = "none";
    } else {
      setVolume(0);
      volumeIcon.style.display = "none";
      volumeMutedIcon.style.display = "block";
    }
  });

  document.getElementById("play-pause").addEventListener("click", function () {
    togglePlayPause();
  });

  function togglePlayPause() {
    if (audio.paused) {
      audio.play();
      playIcon.style.display = "none";
      pauseIcon.style.display = "block";
    } else {
      audio.pause();
      playIcon.style.display = "block";
      pauseIcon.style.display = "none";
    }
  }

  function skipTime(seconds) {
    audio.currentTime = Math.max(
      0,
      Math.min(audio.duration, audio.currentTime + seconds)
    );
  }

  document.getElementById("forward-30").addEventListener("click", function () {
    skipTime(30);
  });

  document.getElementById("back-30").addEventListener("click", function () {
    skipTime(-30);
  });

  function seek(event) {
    const timeline = event.currentTarget;
    const rect = timeline.getBoundingClientRect();
    const offsetX = event.clientX - rect.left;
    const percentage = offsetX / rect.width;
    audio.currentTime = percentage * audio.duration;
  }

  document.querySelector(".audio-timeline").addEventListener("click", seek);

  function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  }

  function setVolume(volume) {
    audio.volume = volume;
  }

  const showTranscriptBtn = document.querySelector(
    ".podcast-player__show-transcript"
  );
  const transcriptContainer = document.querySelector(
    ".podcast-player__transcript"
  );
  const transcriptContent = document.querySelector(".transcript-content");

  if (showTranscriptBtn && transcriptContainer && transcriptContent) {
    showTranscriptBtn.addEventListener("click", () => {
      transcriptContainer.classList.toggle("active");
      transcriptContainer.classList.toggle("hidden");

      if (transcriptContainer.classList.contains("active")) {
        showTranscriptBtn.textContent = "Hide Transcript";
      } else {
        showTranscriptBtn.textContent = "Show Transcript";
      }
    });
  }

  if (transcriptContent) {
    transcriptContent.addEventListener("keydown", (e) => {
      const key = e.key;
      if (key === "ArrowDown") {
        e.preventDefault();
        transcriptContent.scrollTop += 20;
      } else if (key === "ArrowUp") {
        e.preventDefault();
        transcriptContent.scrollTop -= 20;
      }
    });
  }
});
